import request from '@/router/axios'

const BASE = '/api/produce/power-room-monitor'

export const electricCurrent = (data) => request({ url: `${BASE}/electric/current`, method: 'post', data })
export const electricIntervalUsage = (data) => request({ url: `${BASE}/electric/interval-usage`, method: 'post', data })
export const electricUsageList = (data) => request({ url: `${BASE}/electric/usage-list`, method: 'post', data })
export const electricSummary = (data) => request({ url: `${BASE}/electric/summary`, method: 'post', data })
export const electricPointImportExcel = (data) => request({
  url: `${BASE}/point/import-excel`,
  method: 'post',
  data,
  headers: { 'Content-Type': 'multipart/form-data' }
})
